(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-carousel"]) return;
  try {
    
  function setEqualCarouselHeights() {
    const items = document.querySelectorAll('.content-carousel');
    let maxHeight = 0;

    items.forEach(el => {
      const original = {
        display: el.style.display,
        visibility: el.style.visibility,
        position: el.style.position
      };

      // Temporarily show hidden slides
      el.style.display = 'block';
      el.style.visibility = 'hidden';
      el.style.position = 'absolute';

      const h = el.scrollHeight;
      if (h > maxHeight) maxHeight = h;

      // Restore
      el.style.display = original.display;
      el.style.visibility = original.visibility;
      el.style.position = original.position;
    });

    // Apply min-height
    items.forEach(el => {
      el.style.minHeight = maxHeight + 'px';
    });
  }

  // Run early
  document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(setEqualCarouselHeights);
  });

  window.addEventListener('resize', setEqualCarouselHeights);



  (function () {
    setEqualCarouselHeights();
    const carousel = new bootstrap.Carousel('#communityCarousel');
    const $caouselEle = document.getElementById('communityCarousel');

    const length = Number($caouselEle.getAttribute('data-length'));

    const nextBtn = document.querySelector('.communityCarousel__next');
    const prevBtn = document.querySelector('.communityCarousel__prev');

    $caouselEle.addEventListener('slide.bs.carousel', (event) => {
      prevBtn.classList.remove('imageCarousel__arrow-disable');

      if (event.to === length - 1) {
        nextBtn.classList.add('imageCarousel__arrow-disable');
      } else {
        nextBtn.classList.remove('imageCarousel__arrow-disable');
      }

      if (event.to === 0) {
        prevBtn.classList.add('imageCarousel__arrow-disable');
      } else {
        prevBtn.classList.remove('imageCarousel__arrow-disable');
      }
    });


    document.querySelectorAll('.content-carousel').forEach(carousel => {
      const maxHeight = Math.max(
        ...[...carousel.querySelectorAll('.slide')].map(s => s.offsetHeight)
      );
      carousel.style.height = maxHeight + "px";
    });
  })();

  (function() {
    const selectorItem = '.carousel-item';
    const selectorContent = '.content-carousel';

    function equalizeCarouselContentHeights() {
      const items = Array.from(document.querySelectorAll(selectorItem));
      if (!items.length) return;

      // Save original inline style so we can restore exactly later
      const originalStyles = new Map();
      items.forEach(item => originalStyles.set(item, item.getAttribute('style') || ''));

      // Make every slide measurable off-screen & invisible
      items.forEach(item => {
        item.style.display = 'block';
        item.style.position = 'absolute';
        item.style.visibility = 'hidden';
        // Keep the same width as when it's in the carousel to measure properly
        // if carousel has a fixed width or parent constraints, we can set width from computed style:
        const parentWidth = item.parentElement ? item.parentElement.clientWidth : null;
        if (parentWidth) item.style.width = parentWidth + 'px';
      });

      // Measure
      let maxH = 0;
      items.forEach(item => {
        const content = item.querySelector(selectorContent);
        if (!content) return;
        // Reset content's inline height to natural height before measuring
        content.style.height = 'auto';
        const h = content.getBoundingClientRect().height;
        if (h > maxH) maxH = h;
      });

      // Restore original slide styles
      items.forEach(item => {
        const saved = originalStyles.get(item) || '';
        if (saved) item.setAttribute('style', saved);
        else item.removeAttribute('style');
      });

      // Apply the max height to all .content-carousel (use px)
      if (maxH > 0) {
        document.querySelectorAll(selectorContent).forEach(el => {
          el.style.height = Math.ceil(maxH) + 'px';
          el.style.overflow = 'hidden'; // optional: prevent jumps
        });
      }
    }

    // Recalculate when:
    window.addEventListener('load', equalizeCarouselContentHeights);
    window.addEventListener('resize', () => {
      // clear heights, then recalc to allow responsive changes
      document.querySelectorAll(selectorContent).forEach(el => el.style.height = 'auto');
      // small debounce
      clearTimeout(window.__equalizeCarouselTimer);
      window.__equalizeCarouselTimer = setTimeout(equalizeCarouselContentHeights, 120);
    });

    // Recalc when images inside slides load (use capture per-image)
    document.querySelectorAll('.carousel-item img').forEach(img => {
      if (!img.complete) {
        img.addEventListener('load', () => {
          document.querySelectorAll(selectorContent).forEach(el => el.style.height = 'auto');
          equalizeCarouselContentHeights();
        });
      }
    });

    // If you're using Bootstrap's carousel, recalc after slide completes (safe to call even if not using bootstrap)
    const carouselEl = document.querySelector('.carousel');
    if (carouselEl) {
      carouselEl.addEventListener('slid.bs.carousel', () => {
        // ensure active slide has correct height too
        document.querySelectorAll(selectorContent).forEach(el => el.style.height = 'auto');
        equalizeCarouselContentHeights();
      });
    }

    // initial call (best-effort)
    equalizeCarouselContentHeights();

    // expose for debugging if needed
    window.equalizeCarouselContentHeights = equalizeCarouselContentHeights;
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community"]) return;
  try {
    
  (function () {
    const carousel = new bootstrap.Carousel('#communityCarousel');
    const $caouselEle = document.getElementById('communityCarousel');

    const length = Number($caouselEle.getAttribute('data-length'));

    const nextBtn = document.querySelector('.communityCarousel__next');
    const prevBtn = document.querySelector('.communityCarousel__prev');

    $caouselEle.addEventListener('slide.bs.carousel', (event) => {
      prevBtn.classList.remove('imageCarousel__arrow-disable');

      if (event.to === length - 1) {
        nextBtn.classList.add('imageCarousel__arrow-disable');
      } else {
        nextBtn.classList.remove('imageCarousel__arrow-disable');
      }

      if (event.to === 0) {
        prevBtn.classList.add('imageCarousel__arrow-disable');
      } else {
        prevBtn.classList.remove('imageCarousel__arrow-disable');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [... tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))


  } catch(e) { console.error(e); }
})();
})();
